/* eslint-disable max-len */
import { h, Fragment } from 'preact';
import Image from 'utils/image';
import { truncateString } from '../utils/helpers';
import AddToCartButton from './product-add-to-cart';
import { useWindowSize } from '../utils/window-size';

const UpsellProduct = ({ currentVariant }) => {
  const { isTablet, isMobile } = useWindowSize();
  return (
    <>
      {currentVariant?.availableForSale && (
        <div className="mb-8 px-5 laptop:px-0">
          <p className="subheading-h4 text-black mb-2">
            {TMW.Strings.product.upsellTitle}
          </p>
          <div className="flex gap-[17px] justify-between mb-2 laptop:mb-0">
            <div className="flex justify-center max-w-[124px] laptop:max-w-[154px]">
              <a
                href={`${window.Shopify.routes.root}products/${currentVariant.product.handle}`}
                target="_blank"
                rel="no-referrer noreferrer"
                className="no-underline before:hidden"
              >
                <Image
                  src={currentVariant?.image?.url}
                  srcWidths={{
                    sm: 214,
                    md: 262,
                  }}
                />
              </a>
            </div>
            <div className="flex flex-col justify-between">
              <div>
                <p className="font-14-bold text-black mb-1">
                  {currentVariant.product.title}
                </p>
                {currentVariant.product.sizeOption && (
                  <p className="utility-1 text-charcoal mb-1">
                    Size: {currentVariant.product.sizeOption.value}
                  </p>
                )}
                {currentVariant.product.shortDescription ? (
                  <p className="font-13 text-black laptop:mb-3">
                    {currentVariant.product.shortDescription.value}
                  </p>
                ) : (
                  <p className="font-13 text-black laptop:mb-3">
                    {truncateString(currentVariant.product.description, 70)}
                  </p>
                )}
              </div>
              {!isTablet && !isMobile && (
                <AddToCartButton
                  currentVariant={currentVariant}
                  currentProduct={currentVariant.product}
                  showQty={false}
                  showPrice={true}
                  isMargin={false}
                  showMessage={false}
                  btnFont="cta-small"
                  btnStyle="btn-primary-stroke"
                  customButtonClass="!p-[12px]"
                />
              )}
            </div>
          </div>
          {(isTablet || isMobile) && (
            <AddToCartButton
              currentVariant={currentVariant}
              currentProduct={currentVariant.product}
              showQty={false}
              showPrice={true}
              isMargin={false}
              showMessage={false}
              btnStyle="btn-primary-stroke"
            />
          )}
        </div>
      )}
    </>
  );
};

export default UpsellProduct;
